



















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Socials extends Vue {
  @Prop() collection!: any
}
